<template>
  <div>
    <span>{{ title }}</span>
    <a-tooltip placement="top">
      <template #title>
        <span>{{ tip }}</span>
      </template>
      <QuestionCircleOutlined style="margin-left: 5px"/>
    </a-tooltip>
  </div>
</template>
<script setup lang="tsx">
import {QuestionCircleOutlined} from '@ant-design/icons-vue'

defineProps(['title', 'tip'])
</script>
